/**
 * Created by andrey on 24.05.17.
 */

const Fireworks = cc.Node.extend({
    ctor: function () {
        this._super();

        this.setAnchorPoint(0.5, 0.5);

        this.started = false;

        this.onResize();
    },

    start: function () {
        if (this.started) {
            return;
        }
        this.started = true;
        this.process();
    },

    stop: function () {
        if (this.started) {
            this.started = false;
        }
    },

    onEnter: function () {
        this._super();

        cleverapps.bundleLoader.loadBundle("fireworks", {
            onSuccess: function () {
                this.process();
            }.bind(this)
        });
    },

    onExit: function () {
        this._super();

        cleverapps.bundleLoader.deleteBundle("fireworks");
    },

    onResize: function () {
        const sceneSize = cleverapps.resolution.getSceneSize();
        const deltaX = (sceneSize.width - this.width) / 2;
        const deltaY = (sceneSize.height - this.height) / 2;

        this.setContentSize(sceneSize);
        this.setAlignment(sceneSize.width / 2, sceneSize.height / 2);

        this.children.forEach((child) => {
            child.setPosition(child.x + deltaX, child.y + deltaY);
        });
    },

    process: function () {
        if (!this.started || !cleverapps.bundleLoader.isLoaded("fireworks")) {
            return;
        }

        this.confettiAnimation();
    },

    confettiAnimation: function () {
        const fireworks = new cleverapps.Spine(bundles.fireworks.jsons.confetti_json);

        if (["heroes", "tropical"].indexOf(cleverapps.config.ui) === -1) {
            cleverapps.UI.fitToBox(fireworks, {
                minScale: 0.6,
                width: this.parent.width
            });
        }

        fireworks.setAnimation(0, "animation1", false);
        fireworks.setCompleteListenerRemove();
        fireworks.setAlignment(this.width / 2, this.height / 2);
        this.addChild(fireworks);

        cleverapps.effects.fire("ui.fireworks.confetti");
    }
});